export default "__VITE_ASSET__D32qbg7E__"